import { commitmentsFromRejection } from "../../Projects/api/pending-commitments.ts"
import type {
  StatusChangeOptions,
  StatusChangeOutcome
} from "../components/ProjectStatusSelector.tsx"

interface Acknowledgement {
  cancel_appointments?: true
}

export const sendStatusChange = async (
  send: (acknowledgement: Acknowledgement) => PromiseLike<unknown>,
  options?: StatusChangeOptions
): Promise<StatusChangeOutcome> => {
  try {
    await send(options?.cancelAppointments ? { cancel_appointments: true } : {})
  } catch (e) {
    return commitmentsFromRejection(e)
  }
}
